import { breakpoints } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';
import styled from 'styled-components';

export const ModalContent = styled.div`
  position: relative;
  display: flex;

  width: 100%;
  min-height: 70px;

  overflow: hidden;

  align-items: flex-start;
`;

export const Content = styled('div')`
  display: flex;
  align-items: center;
  gap: 24px;

  overflow: hidden;
  white-space: break-spaces;
  flex-wrap: wrap;

  @media (max-width: ${breakpoints.smallTablet}) {
    gap: 16px;
  }
`;

export const Header = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const Title = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;

  flex-grow: 1;
`;

export const Icon = styled('div')``;

export const DiscountValue = styled.h4`
  font-size: 33px;
  font-weight: 700;
  line-height: 32px;
  margin: 0;
  white-space: nowrap;

  color: ${LayoutColors.blackMain};

  @media (max-width: ${breakpoints.smallTablet}) {
    font-size: 23px;
  }
`;

export const Message = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;

  color: ${LayoutColors.blackMain};
  margin-bottom: 0;

  @media (max-width: ${breakpoints.smallTablet}) {
    font-size: 13px;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  font-size: 24px;

  color: inherit;
`;

interface ContinueButtonProps {
  $mainColor: string;
  $textColor: string;
}

export const ContinueButton = styled.button<ContinueButtonProps>`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin: 0;

  background-color: ${(props) => props.$mainColor};
  color: ${(props) => props.$textColor};

  width: fit-content;
  padding: 10px 47px 10px 47px;
  border-radius: 4px;

  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;

  @media (max-width: ${breakpoints.smallTablet}) {
    width: 100%;
  }
`;
